import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CitationsDeletionFromDocumentEditing from './citationsdeletionfromdocumentediting';

export default class CitationsDeletionFromDocument extends Plugin {
  static get requires() {
    return [CitationsDeletionFromDocumentEditing];
  }

  static get pluginName() {
    return 'CitationsDeletionFromDocument';
  }
}
